/*/ Node URL /*/
//export const nodeURL = 'http://localhost:6162/'
//export const nodeURL = 'https://levhaapi.trabzon.bel.tr/api/'

const MunicipalityNaneFront = [
  {
    name: "Trabzon Büyükşehir Belediyesi",
    border: [
      {
        extent: [
          4315988.08013191, 4919840.524252195, 4517166.668862914,
          5060262.559221601,
        ],
        kod: "0",
        ad: `Büyükşehir Belediyesi`,
      },
    ],
    nodeURL: "https://adres.trabzon.bel.tr/kapi/",
    //nodeURL: "http://localhost:6162/",
  },
  {
    name: "Şanlıurfa Büyükşehir Belediyesi",
    border: [
      {
        extent: [
          4154658.37660559, 4373515.54203507, 4612013.19095976,
          4610366.29989386,
        ],
        kod: "0",
        ad: `Büyükşehir Belediyesi`,
      },
    ],
    nodeURL: "https://adres.sanliurfa.bel.tr/api/",
  },
  {
    name: "Kocaeli Büyükşehir Belediyesi",
    border: [
      {
        extent: [
          4154658.37660559, 4373515.54203507, 4612013.19095976,
          4610366.29989386,
        ],
        kod: "0",
        ad: `Büyükşehir Belediyesi`,
      },
    ],
    nodeURL: "https://adres.sanliurfa.bel.tr/api/",
  },
];

export const MunicipalityNaneFrontSetting = MunicipalityNaneFront[0];
